const DEFAULT_SORT_TYPE = "desc";

const DEFAULT_PER_PAGE_DROPDOWN = [10, 50, 100];

export { DEFAULT_SORT_TYPE, DEFAULT_PER_PAGE_DROPDOWN };
